import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function Slidertwo() {
  const data = [
    {
      id: 1,
      name: "Richard M. Pappas",
      img: "assets/images/resources/testi-2-1.png",
    },
    {
      id: 2,
      name: "Richard M. Pappas",
      img: "assets/images/resources/testi-2-1.png",
    },
    {
      id: 3,
      name: "Richard M. Pappas",
      img: "assets/images/resources/testi-2-1.png",
    },
    {
      id: 4,
      name: "Richard M. Pappas",
      img: "assets/images/resources/testi-2-1.png",
    },
    {
      id: 5,
      name: "Richard M. Pappas",
      img: "assets/images/resources/testi-2-1.png",
    },
  ];

  return (
    <>
      <section className="testimonials-two">
        <img
          src="assets/images/background/testi-2-bg-1.jpg"
          className="testimonials-two__bg"
          alt="Testimonials Background"
        />
        <div className="container">
          <div className="sec-title text-start">
            <p className="sec-title__tagline">Clients testimonials</p>
            <h3 className="sec-title__title count-box">What customer say us</h3>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <Swiper
                loop={true}
                spaceBetween={30}
                slidesPerView={1}
              >
                {data.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div
                      className="testimonials-card-two"
                      style={{ "--accent-color": "#1da1f2" }}
                    >
                      <div className="testimonials-card-two__top">
                        <div className="testimonials-card-two__info">
                          <div className="testimonials-card-two__image">
                            <img src={item.img} alt={item.name} />
                          </div>
                          <div className="testimonials-card-two__info__content">
                            <h3 className="testimonials-card-two__name">
                              {item.name}
                            </h3>
                            <p className="testimonials-card-two__designation">
                              Senior Manager
                            </p>
                          </div>
                        </div>

                        <div className="testimonials-card-two__review">
                          <div className="testimonials-card-two__icon">
                            <i className="fab fa-twitter"></i>
                          </div>
                          <div className="testimonials-card-two__review__content">
                            <h3 className="testimonials-card-two__review__title">
                              Quality Services
                            </h3>
                            <p className="testimonials-card-two__stars">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="testimonials-card-two__content">
                        Sed ut perspiciatis unde omnis iste natus voluptatem
                        accusantium doloremque laudantium totarem aperiam eaquey
                        quae abillo inventore veritatis et quasi architecto
                        beatae vitae dicta sunt explicabo.
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Slidertwo;
